import { render } from "./NotesContainer.vue?vue&type=template&id=536abd32&scoped=true"
import script from "./NotesContainer.vue?vue&type=script&lang=js"
export * from "./NotesContainer.vue?vue&type=script&lang=js"

import "./NotesContainer.vue?vue&type=style&index=0&id=536abd32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536abd32"]])

export default __exports__